import {
  Box,
  Button,
  Drawer,
  IconButton,
  Popover,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import ForwardIcon from "@mui/icons-material/Forward";
import { useLocation, useNavigate } from "react-router-dom";
import useControlledNavigation from "../../hooks/useControlledNavigation";

const SideNavButtons = () => {
  // const [open,setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const theme = useTheme();

  const location = useLocation();

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  console.log(location, "++++location");
  const navigation = useControlledNavigation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  // const locationToGide = ["?active=ProfitAndLoss","?active=Business_Overview","?active=BalanceSheet","?active=Receivables","?active=Payables","?active=TrialBalance","?active=Items"]

  // if(locationToGide.includes(location.search)){
  //     return null
  // }
  return (
    <Box>
      {!isSmallScreen ? (
        <div
          style={{
            position: "fixed",
            top: "200px",
            right: "5px",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
         
        >
          <Tooltip title="Profit and Loss" placement="left">
            <Button
              variant="contained"
              sx={{
                width: "5px",
                minWidth: "unset",
                fontSize: "10px",
                padding: "6px 8px",
                lineHeight: "1.2",
                background: "linear-gradient(180deg, #FD5380 0%, #D91C80 100%)",
              }}
              onClick={() => navigation("/?active=ProfitAndLoss")}
            >
              P<br />&<br />L
            </Button>
          </Tooltip>
          <Tooltip title="Balance Sheet" placement="left">
            <Button
              variant="contained"
              sx={{
                width: "5px",
                minWidth: "unset",
                fontSize: "10px",
                padding: "6px 8px",
                lineHeight: "1.2",
                background: "linear-gradient(180deg, #FD5380 0%, #D91C80 100%)",
              }}
              onClick={() => navigation("/?active=BalanceSheet")}
            >
              B<br />S
            </Button>
          </Tooltip>
        </div>
      ) : (
        <div>
          <IconButton
            onClick={handleOpen}
            sx={{
              position: "fixed",
              bottom: "100px",
              right: "20px",
              backgroundColor: "#D91C80",
              color: "white",
              zIndex: 1301,
              height: "15px",
              width: "15px",
            }}
          >
            <ForwardIcon
              sx={{ height: "12px", width: "12px", rotate: "180deg" }}
            />
          </IconButton>

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            PaperProps={{
              sx: {
                p: 1,
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          >
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                variant="contained"
                sx={{
                  width: "60px",
                  minWidth: "unset",
                  fontSize: "8px",
                  padding: "6px 8px",
                  lineHeight: "1.2",
                  background:
                    "linear-gradient(180deg, #FD5380 0%, #D91C80 100%)",
                  height: "20px",
                }}
                onClick={() => {
                  setAnchorEl(null);
                  navigation("/?active=ProfitAndLoss");
                }}
              >
                P&L
              </Button>

              <Button
                variant="contained"
                sx={{
                  width: "60px",
                  minWidth: "unset",
                  fontSize: "8px",
                  padding: "6px 8px",
                  lineHeight: "1.2",
                  background:
                    "linear-gradient(180deg, #FD5380 0%, #D91C80 100%)",
                  height: "20px",
                }}
                onClick={() => {
                  setAnchorEl(null);
                  navigation("/?active=BalanceSheet");
                }}
              >
                BS
              </Button>
            </div>
          </Popover>
        </div>
      )}
    </Box>
  );
};

export default SideNavButtons;
